import { apiSlice } from "./apiSlice";

export const leadsSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get all Leads list
        getLeadsList: builder.query({
            query: (params) => ({
                url: `Lead`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllLeads"],
        }),

        // Create new Leads
        createLeads: builder.mutation({
            query: (body) => ({
                url: `Lead`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["AllLeads"],
        }),

        getExportLeads: builder.query({
            query: (params) => ({
                url: `Lead`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

        // Update Leads
        updateLeads: builder.mutation({
            query: (body) => ({
                url: `Lead`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ['AllLeads']
        }),

        // Delete Leads
        deleteLeads: builder.mutation({
            query: (id) => ({
                url: `Lead/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['AllLeads']
        }),

        // Get all Leads list (Prject wise for Deal Tracker)
        getProjectLeadsList: builder.query({
            query: (projectId) => ({
                url: `Lead/project/${projectId}`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllLeads"],
        }),

    })
})

export const { useLazyGetLeadsListQuery, useCreateLeadsMutation, useUpdateLeadsMutation, useDeleteLeadsMutation, useGetProjectLeadsListQuery, useLazyGetExportLeadsQuery } = leadsSlice;